<ph-dialog [open]="!!(open$ | async)"
           size="sm"
           heading="Your session is about to expire"
           description="You are being signed out because you have been inactive. Do you want to stay signed in?"
           [dismissible]="false">
    <strong *ngIf="countdown$ | async as count">Time remaining: {{ count }} {{ count === 1 ? 'second' : 'seconds' }}</strong>

    <ph-actions slot="footer">
        <ph-button variant="secondary" mode="filled" type="button" (click)="signOut()">Sign out now</ph-button>
        <ph-button type="button" (click)="staySignedIn()">Stay signed in</ph-button>
    </ph-actions>
</ph-dialog>
